import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TableForm } from 'components/Commons';
import styled from 'styled-components';

const propTypes = {
  holidays: PropTypes.arrayOf(PropTypes.any).isRequired
};
const defaultProps = {};

const HolidayResult = ({ holidays }) => {
  const makeBody = () => {
    const tableData = {
      header: {
        main: [
          { data: '시작일', textAlign: 'center' },
          { data: '마지막일', textAlign: 'center' },
          { data: '기간', textAlign: 'center' },
          { data: '공휴일명', textAlign: 'center' },
          { data: '설명', textAlign: 'center' },
          { data: '활성', textAlign: 'center' },
          { data: '마지막 수정일', textAlign: 'center' }
        ]
      },
      body: {
        message: '선택한 연도의 공휴일이 설정되지 않았습니다. 식권대장에 문의해주세요.',
        main: null
      }
    };

    if (holidays.length > 0) {
      tableData.body.main = holidays.map((item) => {
        return {
          row: [
            {
              data: moment(item.startDate).format('YYYY-MM-DD'),
              textAlign: 'center'
            },
            {
              data: moment(item.endDate).format('YYYY-MM-DD'),
              textAlign: 'center'
            },
            {
              data: item.duration,
              textAlign: 'center'
            },
            {
              data: item.name,
              textAlign: 'center'
            },
            {
              data: item.description,
              textAlign: 'left'
            },
            {
              data: item.isActive ? '활성' : <StyledSpan>비활성</StyledSpan>,
              textAlign: 'center'
            },
            {
              data: !item.updateDate
                ? moment(item.createDate).format('YYYY-MM-DD HH:mm:ss')
                : moment(item.updateDate).format('YYYY-MM-DD HH:mm:ss'),
              textAlign: 'center'
            }
          ]
        };
      });
    }
    return tableData;
  };

  const tableData = makeBody();
  return (
    <div>
      <div className="holidayList">
        <TableForm selectable="true" tabledata={tableData} />
      </div>
    </div>
  );
};

const StyledSpan = styled.span`
  color: red;
`;

HolidayResult.propTypes = propTypes;
HolidayResult.defaultProps = defaultProps;

export default HolidayResult;
